import { useEffect, useState, useMemo } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import AppFullScreen from './components/AppFullScreen'
import { isAuthenticated } from './components/auth/AuthServices'
import SignIn from './components/user/SignIn'
import LoadingSpinner from './custom-components/LoadingSpinner'
import { ENV_ACTIONS } from './reducers/environmentReducer'
import queryString from 'query-string'
import { Helmet } from 'react-helmet'
import _, { isEmpty, isEqual } from 'lodash'
import { CSP, DATAGRIDPREMIUMKEY } from './config'
import { auth, signInFirebaseWithCustomToken } from 'firebase-config'

const useStyles = makeStyles(() => ({
	layoutFullscreen: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		position: 'relative',
		height: '100vh',
	},
}))

const CookiebotScript = ({ cookiebotId }) => {
	return (
		<Helmet>
			<script
				id="Cookiebot"
				src="https://consent.cookiebot.com/uc.js"
				data-cbid={cookiebotId}
				type="text/javascript"
				async
			/>
		</Helmet>
	)
}

const App = () => {
	const classes = useStyles()

	const environment = useSelector((state) => state.environment)
	const dispatch = useDispatch()
	// const userSession = isAuthenticated();
	const [userSession, setUserSession] = useState(isAuthenticated())
	const showLoading = () => environment.isLoading && <LoadingSpinner />

	const initializedEnvironment = () => {
		dispatch({
			type: ENV_ACTIONS.INITIALIZED_ENVIRONMENT,
		})
	}

	const checkSession = () =>
		userSession &&
		dispatch({
			type: ENV_ACTIONS.GET_USER,
			payload: {
				user: userSession,
			},
		})

	useEffect(() => {
		const allowedDomains = JSON.parse(localStorage.getItem('allowedDomains'))
		if (!allowedDomains || isEmpty(allowedDomains)) {
			if (!CSP) return
			const domains = CSP.split(/\s+/)
				.map((d) => d.trim())
				.filter(Boolean)

			localStorage.setItem('allowedDomains', JSON.stringify(domains))
		}
	}, [])

	useEffect(() => {
		const currentUser = auth?.currentUser
		if (!currentUser) {
			signInFirebaseWithCustomToken({ firebaseToken: userSession?.firebaseToken })
		}
	}, [userSession])

	const renderApp = () => {
		const localAllowedDomains = JSON.parse(localStorage.getItem('allowedDomains'))
		return userSession ? (
			<>
				{localAllowedDomains?.length > 0 && (
					<Helmet>
						<meta
							httpEquiv="Content-Security-Policy"
							content={`frame-src ${localAllowedDomains.join(' ')};`}
						/>
					</Helmet>
				)}
				<AppFullScreen
					isAuthenticated={environment.isAuthenticated}
					apiToken={environment.apiToken}
					timeoutMinutes={environment?.settings?.portal?.security?.timeoutMinutes}
					lockEnabled={environment?.settings?.portal?.security?.lockEnabled}
				/>
			</>
		) : (
			<SignIn />
		)
	}

	useEffect(() => {
		initializedEnvironment()
		checkSession()
	}, [])

	useEffect(() => {
		setUserSession(environment.isAuthenticated)
	}, [environment.isAuthenticated])

	useEffect(() => {
		// Set token when open Doforms from Geotab
		const searchParams = new URL(document.location).searchParams
		const data = queryString.parse(searchParams.toString())

		if (!_.isEmpty(data) && data.isFromGeotab) {
			if (data.isAddInGeotabPage) {
				sessionStorage.clear()
			}
			sessionStorage.setItem('isAddInGeotabPage', data.isAddInGeotabPage || false)
			sessionStorage.setItem('jwt', JSON.stringify(data))
			const url = new URL(window.location.href)
			url.search = ''
			const newUrl = url.toString()
			window.location.href = newUrl
		}
	}, [])

	return (
		<div className={classes.layoutFullscreen}>
			{showLoading()}
			{renderApp()}
			<CookiebotScript cookiebotId="e466412a-c3a3-4ab2-aff1-98c475d1f3b4" />
		</div>
	)
}

const mapStateToProps = (state) => {
	return {
		environment: state.environment,
		formsModule: state.formsModule,
		lookupsModule: state.lookupsModule,
	}
}

export default connect(mapStateToProps)(App)
